// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","gladlyHelpCenter":"glady-help-center_gladlyHelpCenter__4KJca"};